import { render, staticRenderFns } from "./prologueManage.vue?vue&type=template&id=8f978d88&scoped=true"
import script from "./prologueManage.vue?vue&type=script&lang=js"
export * from "./prologueManage.vue?vue&type=script&lang=js"
import style0 from "./prologueManage.vue?vue&type=style&index=0&id=8f978d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f978d88",
  null
  
)

export default component.exports